import { render, staticRenderFns } from "./List.vue?vue&type=template&id=bf498ff6&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=bf498ff6&lang=sass&scoped=true&"
import style1 from "./List.vue?vue&type=style&index=1&id=bf498ff6&lang=sass&scoped=true&"
import style2 from "./List.vue?vue&type=style&index=2&lang=css&"
import style3 from "./List.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf498ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf498ff6')) {
      api.createRecord('bf498ff6', component.options)
    } else {
      api.reload('bf498ff6', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=bf498ff6&scoped=true&", function () {
      api.rerender('bf498ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BookMenu/List.vue"
export default component.exports